/* eslint-disable max-len */
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import moment from 'moment';

@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RemarksComponent implements OnInit {

  updateInProgress: boolean = false;
  dialogTitle: string = '';
  jobDetails: any;
  warnings: any;
  formatedWarnings: string;
  reason: string = '';
  dateFormat: any;
  timeFormat: any;
  startDateTime: string;
  endDateTime: string;
  blockJobsOnHoliday: boolean = true;
  holidayName: string;
  isHoliday: boolean;
  constructor(
    private _utilityService: UtilityService,
    private _dispatchBoardService: DispatchBoardService,
    private _localisationService: LocalisationService,
    private dialogRef: MatDialogRef<RemarksComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any

  ) { }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    this.dateFormat = this._utilityService.dateFormat;
    this.timeFormat = this._utilityService.timeFormat;
    this.jobDetails = this.dialogData?.data.jobDetails;
    this.warnings = this.dialogData?.data.warnings;
    this.startDateTime = moment(this.dialogData?.data?.startDateTime).tz(this.dialogData?.data?.timeZone).format(this.dateFormat + ' ' + this.timeFormat);
    this.endDateTime =  moment(this.dialogData?.data?.endDateTime).tz(this.dialogData?.data?.timeZone).format(this.dateFormat + ' ' + this.timeFormat);
    this.dialogTitle = this.getDialogTitle(this.jobDetails);
    this.formatedWarnings = this._dispatchBoardService.formatScheduleWarnings(this.warnings);
    [this.isHoliday, this.holidayName, this.blockJobsOnHoliday] = this._dispatchBoardService.isConflictWithHolidays(this.dialogData?.data.startDateTime, this.dialogData?.data.endDateTime);
  }

  getDialogTitle(jobDetails: any): string {
    const prefix = _.get(jobDetails, 'prefix') || '';
    const workOrderNumber = _.get(jobDetails, 'work_order_number') || '';
    const jobTitle = _.get(jobDetails, 'job_title') || '';
    return `${this._utilityService.getLocaleValue('text.reschedule_job', 'Reschedule Job')} '${workOrderNumber !== '' ? '#' : ''}${prefix} ${workOrderNumber} ${jobTitle}'`;
  }

  rescheduleJob(): void {
    this.updateInProgress = true;
    const jobUid = this.jobDetails?.job_uid;
    const scheduledStartTime = moment.utc(this.dialogData?.data.startDateTime).format('YYYY-MM-DD HH:mm:ss');
    const scheduledEndTime = moment.utc(this.dialogData?.data.endDateTime).format('YYYY-MM-DD HH:mm:ss');
    this._dispatchBoardService.scheduleAndAssignJob(jobUid, scheduledStartTime, scheduledEndTime, 'RESCHEDULE', this.reason, false, null, null, false, null, null, (status)=>{
      this.dialogRef.close(status);
      this.updateInProgress = false;
    });
  }
}
